export default __webpack_public_path__ + "static/media/solution-museum.7faf576c.png";